import { render, staticRenderFns } from "./CertificationRequirements.vue?vue&type=template&id=75edf2be"
import script from "./CertificationRequirements.vue?vue&type=script&lang=js"
export * from "./CertificationRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports